const getDefaultState = () => {
  return {
    location: {},
    errorCode: undefined
  }
}

const state = getDefaultState()

const getters = {
  getLocation: (state) => state.location,
  getErrorCode: (state) => state.errorCode
}

const actions = {
  fetchLocation ({ commit }) {
    return new Promise((resolve, reject) => {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude
          const lng = position.coords.longitude
          commit('setLocation', { lat, lng })

          resolve()
        },
        (error) => {
          if (error.code) {
            commit('setErrorCode', error.code)
            reject()
          }
        },
        options
      )
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setLocation (state, location) {
    state.location = location
  },
  setErrorCode (state, errorCode) {
    state.errorCode = errorCode
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
